import * as React from 'react';
import Menu from '@mui/material/Menu';
import Fade from '@mui/material/Fade';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TextField from '@mui/material/TextField';
import SecondaryButton from '../SecondaryButton';

const CustomFilterSearchDropdown = (props) => {

    const filteredData = props?.data?.filter(item =>
        item?.label?.toLowerCase()?.includes(props?.dropSearchValue?.toLowerCase())
    );

    return (
        <div>
            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                    sx: {
                        padding: 0, // Remove default padding
                    }
                }}
                title={props.selectedValue}
                className={`customDropDownFilter ${props.customClass}`}
                anchorEl={props.anchorEl}
                open={props.open}
                onClose={props.handleClose}
                TransitionComponent={Fade}
            >
                {/* Fixed Search Bar Section */}
                <div>
                    <TextField
                        value={props?.dropSearchValue}
                        onChange={props?.handleSearchChange}
                        placeholder="Search..."
                        variant="outlined"
                        size="small"
                        fullWidth
                        margin="dense"
                    />
                </div>

                {/* Scrollable List Section */}
                <div style={{ 
                    maxHeight: '400px', // Adjust this value as needed
                    overflowY: 'auto',
                    padding: '0 5px'
                }}>
                    {filteredData.map((item, index) => (
                        <RadioGroup 
                            onChange={props.onChange} 
                            id={item?.id} 
                            key={index} 
                            title={item?.label} 
                            value={props.selectedValue}
                            style={{ padding: '0 0' }}
                        >
                            <FormControlLabel value={item.value} label={item.label} control={<Radio />} />
                        </RadioGroup>
                    ))}
                </div>

                {/* Clear Button Section */}
                {props.onClickClear && (
                    <div style={{ 
                        padding: '0', 
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}>
                        <SecondaryButton customClsName='resetBtn' title={'Clear'} onClick={props.onClickClear} />
                    </div>
                )}
            </Menu>
        </div>
    );
}

export default CustomFilterSearchDropdown;
